<div class="container">
  <mat-tab-group [selectedIndex]="selected.value" (selectedTabChange)="selectedTabChange($event)">
    <mat-tab [label]="title" >
      <div  class="mt-4">
        <data-table
          [title]="title"
          [columns]='columnsIncomeDispatch'
          [configuration]='configurationIncomeDispatch'
          [reloadTable]='reloadTablaIncomeDispatch'
          [params]='paramsIncomeDispatch'
          [url]='EndpointDictionary.HistoricalIncomeDispatch.HISTORICAL_INCOME_DISPATCH_TABLE'
          (add)='addIncomeDispatch($event)'
          (edit)='editIncomeDispatch($event)'
          (view)='viewDetailIncomeDispatch($event)'
          [headerFilters]="headerFilters"
          [headerFileXlsm]="headerFileXlsm"
        ></data-table>
      </div>

    </mat-tab>

    <mat-tab *ngIf="currentState == stateTab.NEWREGISTER && selected.value == 1" [label]="labelTabRegister">

      <app-handler-items
        (listItemComplete)="saveInputInventoryEquipment($event)"
        (goBackButton)="goBackButtonHandlerItems($event)"
        [itemsData]="[]"
        [addWarehouse]="false"
        [addRentalOrder]="true"
        [paramsRentalOrder]="paramsRentalOrder"
        [showAmount]="false"
        [showCurrentAmount]="false"
        [showUnitMeasurement]="false"
        [showRemoveItemButton]="isIncome"
        [showAddItemButton]="isIncome"
        [rentalorderId]="rentalOrderId"
        [showTotal]="false"
        [titleDialog]="this.labelTabRegister"
        [editCostItem]="false"
        [showDate]="false"
        [urlItemCombo]="EndpointDictionary.EquipmentRental.EQUIPMENT_EQUIPMENT_RENTAL_COMBO"
        labelCodigo="Marca"
        [showDeleteItem]="false"
        >
      </app-handler-items>
    </mat-tab>

    <mat-tab *ngIf="currentState == stateTab.VIEWDETAIL && selected.value == 1" label="Detalle">

      <div>
        <app-button-label [labelsEdit]="labels">
        </app-button-label>

        <data-table
            title=""
            [columns]="columnsDetails"
            [data]="dataDetails"
            [configuration]="configurationDetails"
            [reloadTable]="reloadTablaDetails"
          >
          </data-table>
      </div>
    </mat-tab>

  </mat-tab-group>
 </div>
